import { getUsersAddToGroup } from 'APP/model/group/groupModel';
import { IGetUsersAddToGroupRequest } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

export interface IGetAddUsersToGroup {
  users: User[];
  hasMore: boolean;
  cursor?: string;
}

const LIMIT = 50;

export async function getAddUsersToGroup(
  params: Omit<IGetUsersAddToGroupRequest, 'limit'>
): Promise<IGetAddUsersToGroup> {
  try {
    const { users, hasMore, cursor } = await getUsersAddToGroup({
      ...params,
      limit: LIMIT,
    });
    Entities.usersStore.add(users);
    return {
      users: users.map((user) => Entities.usersStore.getUserById(user.id)!),
      hasMore,
      cursor,
    };
  } catch {
    return {
      users: [],
      hasMore: false,
    };
  }
}
